export const MUX_UPLOAD_STATUS = Object.freeze({
	PREPARING: 'preparing',
	READY: 'ready',
	ERRORED: 'errored'
});
